import React from 'react';

const KevinFransPostCard = () => {
  return (
    <div className="kevn_frans-post-feed" style={{ flex: '1 1 300px' }}>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '230px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2023-12-19">19 Dec 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
                <a
                  className="kevn_frans-post-card-content-link"
                  href="https://kvfrans.com/small-research-tanh-activations-with-ddpg/"
                >
                  Small-Research: Tanh Activations with DDPG
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image article-no-space">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '230px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2023-12-19">19 Dec 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
                <a
                  className="kevn_frans-post-card-content-link"
                  href="https://kvfrans.com/small-research-policy-extraction-in-on-iql/"
                >
                  Small-Research: Policy Extraction in IQL
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="kevn_frans-post-card post tag-small-research no-image no-image">
        <div className="kevn_frans-post-card-content">
          <header className="kevn_frans-post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '230px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2023-12-19">8 Sep 2023</time>
            </span>
            <h3 className="kevn_frans-post-card-title">
              <b>
                <a
                  className="kevn_frans-post-card-content-link"
                  href="https://kvfrans.com/successor-representations-explained/"
                >
                  Successor Representations Explained
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="post-card post no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2023-08-01">1 Aug 2023</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/deriving-the-kl/">
                Deriving the KL divergence loss in variational autoencoders
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research tag-thoughts no-image no-image article-no-space">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2022-05-15">15 May 2022</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/notes-on-aloe/">
                For AGI, we need better tasks. For better tasks, we need open-endedness. (ALOE 2022 Notes)
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-thoughts no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2021-12-06">6 Dec 2021</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/kvfrans-thoughts-nov-15/">
                A Mathematical Definition of Interestingness
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2021-11-12">12 Nov 2021</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/causal-language-model/">
                To extract information from language models, optimize for causal response
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-thoughts no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2021-11-02">2 Nov 2021</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/thoughts-oct-29/">
                Data digesters, ML^2, Interestingness
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2021-06-28">28 Jun 2021</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/clipdraw-exploring-text-to-drawing-synthesis/">
                CLIPDraw: Exploring Text-to-Drawing Synthesis
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2021-04-03">3 Apr 2021</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/stampca-conditional-neural-cellular-automata/">
                StampCA: Growing Emoji with Conditional Neural Cellular Automata
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2020-12-02">2 Dec 2020</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/quality-diversity-evolving-ocean-creatures/">
                Quality Diversity: Evolving Ocean Creatures
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2020-11-12">12 Nov 2020</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/open-endedness-3/">
                Open-Endedness 3: Multicell World
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2020-10-22">22 Oct 2020</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/open-endedness-2-bitwise-chemicals/">
                Open-Endedness 2: Bitwise Chemicals
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
<article className="post-card post tag-research no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2020-10-15">15 Oct 2020</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/open-endedness/">
                Open-Endedness 1: Cellworld
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-games no-image no-image">
      <div className="post-card-content">
        <header className="post-card-header" style={{ display: 'flex' }}>
          <span
            style={{
              color: 'rgb(167, 167, 167)',
              width: '130px',
              minWidth: '130px',
              textAlign: 'right',
              paddingRight: '20px',
            }}
          >
            <time dateTime="2019-11-27">27 Nov 2019</time>
          </span>
          <h3 className="post-card-title">
            <b>
              <a className="post-card-content-link" href="https://kvfrans.com/omakase-5-bullet-dance/">
                Omakase 5: Bullet Dance
              </a>
            </b>
          </h3>
        </header>
      </div>
    </article>
    <article className="post-card post tag-games no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2019-07-21">21 Jul 2019</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a className="post-card-content-link" href="https://kvfrans.com/omakase-1-ropeman/">
                  Omakase 1: Ropeman
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2019-04-08">8 Apr 2019</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a className="post-card-content-link" href="https://kvfrans.com/linking-c-and-python-with-boost-anaconda/">
                  Linking C++ and Python with Boost (Anaconda)
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-games no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2018-07-12">12 Jul 2018</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a className="post-card-content-link" href="https://kvfrans.com/rain-project-the-story-of-building-a-touhou-fangame/">
                  RAIN Project: Evolution of the Game Development Dream
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-research tag-link no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2017-10-26">26 Oct 2017</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://openai.com/research/learning-a-hierarchy"
                >
                  [Link] Learning a Hierarchy
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="post-card post tag-research no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2017-02-28">28 Feb 2017</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/coloring-and-shading-line-art-automatically-through-conditional-gans/"
                >
                  Deepcolor: Automatic Coloring and Shading of Manga-Style Lineart
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-12-29">29 Dec 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/what-is-the-natural-gradient-and-where-does-it-appear-in-trust-region-policy-optimization/"
                >
                  What is the Natural Gradient, and How Does it Work?
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-research no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-12-08">8 Dec 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/speeding-up-trpo-through-parallelization-and-parameter-adaptation/"
                >
                  Speeding Up TRPO Through Parallelization and Parameter Adaptation
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-research no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-12-05">5 Dec 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/colorizing-the-draw-model/"
                >
                  Colorizing the DRAW Model
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      {/* <article className="post-card post tag-research no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2017-02-28">28 Feb 2017</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/coloring-and-shading-line-art-automatically-through-conditional-gans/"
                >
                  Deepcolor: Automatic Coloring and Shading of Manga-Style Lineart
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-12-29">29 Dec 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/what-is-the-natural-gradient-and-where-does-it-appear-in-trust-region-policy-optimization/"
                >
                  What is the Natural Gradient, and How Does it Work?
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-research no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-12-08">8 Dec 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/speeding-up-trpo-through-parallelization-and-parameter-adaptation/"
                >
                  Speeding Up TRPO Through Parallelization and Parameter Adaptation
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-research no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-12-05">5 Dec 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/colorizing-the-draw-model/"
                >
                  Colorizing the DRAW Model
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article> */}
      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-07-01">1 Jul 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/simple-algoritms-for-solving-cartpole/"
                >
                  Simple Reinforcement Learning Methods to Learn CartPole
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-28">28 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/generative-adversial-networks-explained/"
                >
                  Generative Adversarial Networks Explained
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-20">20 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/making-use-of-the-model/"
                >
                  Making Use of the Model
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-15">15 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/the-policy-gradient/"
                >
                  The Policy Gradient
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-15">15 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/visualizing-features-from-a-convolutional-neural-network/"
                >
                  Visualizing Features from a Convolutional Neural Network
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-07">7 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/model-free-prediction-and-control/"
                >
                  Model-Free Prediction and Control
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-05">5 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/planning-policy-evaluation-policy-iteration-value-iteration/"
                >
                  Planning: Policy Evaluation, Policy Iteration, Value Iteration
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-05">5 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/markov-processes-in-reinforcement-learning/"
                >
                  Markov Processes in Reinforcement Learning
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-06-05">5 Jun 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/reinforcement-learning-basics/"
                >
                  Reinforcement Learning Basics
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>

      <article className="post-card post tag-tutorials no-image no-image">
        <div className="post-card-content">
          <header className="post-card-header" style={{ display: 'flex' }}>
            <span
              style={{
                color: 'rgb(167, 167, 167)',
                width: '130px',
                minWidth: '130px',
                textAlign: 'right',
                paddingRight: '20px',
              }}
            >
              <time dateTime="2016-04-06">6 Apr 2016</time>
            </span>
            <h3 className="post-card-title">
              <b>
                <a
                  className="post-card-content-link"
                  href="https://kvfrans.com/neural-style-explained/"
                >
                  Neural Style Explained
                </a>
              </b>
            </h3>
          </header>
        </div>
      </article>
    </div>
  );
};

export default KevinFransPostCard;
